var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3H11.75V1.5C11.75 1.10218 11.592 0.720644 11.3107 0.43934C11.0294 0.158035 10.6478 0 10.25 0L5.75 0C5.35217 0 4.97064 0.158035 4.68934 0.43934C4.40803 0.720644 4.25 1.10218 4.25 1.5V3H0.5V4.5H2V15.75C2 16.3467 2.23705 16.919 2.65901 17.341C3.08097 17.7629 3.65326 18 4.25 18H11.75C12.3467 18 12.919 17.7629 13.341 17.341C13.7629 16.919 14 16.3467 14 15.75V4.5H15.5V3ZM5.75 1.5H10.25V3H5.75V1.5ZM12.5 15.75C12.5 15.9489 12.421 16.1397 12.2803 16.2803C12.1397 16.421 11.9489 16.5 11.75 16.5H4.25C4.05109 16.5 3.86032 16.421 3.71967 16.2803C3.57902 16.1397 3.5 15.9489 3.5 15.75V4.5H12.5V15.75Z",
    fill: "#F02D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 7.5H7.25V13.5H5.75V7.5ZM8.75 7.5H10.25V13.5H8.75V7.5Z",
    fill: "#F02D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.8bda8beacefbab23a7b1a7a7c9aa35ff.svg";
export { ForwardRef as ReactComponent };